// extracted by css-extract-rspack-plugin
export default {"asideContent":"aside-content_NHpuN","aside":"aside_CluAv","logo":"logo_gUblW","logoCollapsed":"logo-collapsed_RkI7X","label":"label_KgAi_"};